export class ReportService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    getTicketsReport(reportRequest) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/analytics/reports/tickets', reportRequest),
        });
    }
    getAttendantsReport(reportRequest) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/analytics/reports/attendants', reportRequest),
        });
    }
    getAttendantStatusReport(reportRequest) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/analytics/reports/attendants/productivity', {
                beginDate: reportRequest.beginDate,
                endDate: reportRequest.endDate,
            }),
        });
    }
    getTeamsReport(reportRequest) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/analytics/reports/teams', reportRequest),
        });
    }
    getTagsReport(reportRequest) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/analytics/reports/tags', reportRequest),
        });
    }
    getTicketsTimings(reportRequest) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri: this.setUriParameters('/analytics/reports/timings', reportRequest),
        });
    }
    getPersonalizedBreaksHistory(userEmail, filter) {
        const email = encodeURIComponent(`${userEmail}@${this.MESSAGINGHUBDOMAIN}`);
        const uri = '/analytics/reports/attendants/pauses-history/'.concat(`${email}?$filter=${filter}`);
        const history = this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            uri,
        });
        return history;
    }
    setUriParameters(baseUri, reportRequest) {
        let uri = baseUri +
            `?version=2&beginDate=${reportRequest.beginDate}&endDate=${reportRequest.endDate}`;
        if (reportRequest.channels && reportRequest.channels.length > 0) {
            uri =
                uri +
                    `&domains=${encodeURIComponent(reportRequest.channels.join(','))}`;
        }
        if (reportRequest.agents && reportRequest.agents.length > 0) {
            uri =
                uri +
                    `&operators=${encodeURIComponent(reportRequest.agents.join(','))}`;
        }
        if (reportRequest.teams && reportRequest.teams.length > 0) {
            uri =
                uri +
                    `&teams=${encodeURIComponent(reportRequest.teams.join(','))}`;
        }
        if (reportRequest.tags && reportRequest.tags.length > 0) {
            uri =
                uri +
                    `&tags=${encodeURIComponent(reportRequest.tags.join(','))}`;
        }
        return uri;
    }
}
ReportService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
